// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 手绘节点样式 - 紧凑小节点 */

.DrawingNode-wrapper {
  padding: 12px;
  width: 200px;
  background: #ffffff;
  cursor: pointer;
  transition: all 0.2s;
  border-radius: 8px;
}

.DrawingNode-wrapper:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

/* 预览区域 */
.DrawingNode-preview {
  width: 100%;
  height: 120px;
  background: #f8f9fa;
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #e9ecef;
  margin-bottom: 10px;
  transition: all 0.2s;
}

.DrawingNode-wrapper:hover .DrawingNode-preview {
  border-color: #667eea;
}

/* 预览图片 */
.DrawingNode-preview-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* 占位符 */
.DrawingNode-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #adb5bd;
  padding: 16px;
  text-align: center;
}

.DrawingNode-placeholder-icon {
  font-size: 36px;
  opacity: 0.6;
  animation: DrawingNode-pulse 2s ease-in-out infinite;
}

@keyframes DrawingNode-pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 0.6;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
}

.DrawingNode-placeholder-text {
  font-size: 12px;
  font-weight: 600;
  color: #6c757d;
}

/* 状态标识 */
.DrawingNode-status {
  display: flex;
  justify-content: center;
  gap: 6px;
  flex-wrap: wrap;
  margin-bottom: 8px;
}

.DrawingNode-status-badge {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.DrawingNode-status-badge-success {
  background: #d4edda;
  color: #155724;
}

.DrawingNode-status-badge-empty {
  background: #fff3cd;
  color: #856404;
}

.DrawingNode-status-badge-warning {
  background: #fff3cd;
  color: #856404;
}

.DrawingNode-status-badge-info {
  background: #d1ecf1;
  color: #0c5460;
}

/* 提示 */
.DrawingNode-hint {
  font-size: 11px;
  color: #6c757d;
  text-align: center;
  padding: 6px;
  background: #f0f4ff;
  border-radius: 4px;
  border-left: 2px solid #667eea;
}

/* 响应式 */
@media (max-width: 768px) {
  .DrawingNode-wrapper {
    width: 160px;
  }
  
  .DrawingNode-preview {
    height: 100px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/canvas/nodes/DrawingNode.css"],"names":[],"mappings":"AAAA,mBAAmB;;AAEnB;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,SAAS;AACT;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,SAAS;AACT;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,oDAAoD;AACtD;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,YAAY;EACd;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,OAAO;AACP;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,QAAQ;AACR;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* 手绘节点样式 - 紧凑小节点 */\n\n.DrawingNode-wrapper {\n  padding: 12px;\n  width: 200px;\n  background: #ffffff;\n  cursor: pointer;\n  transition: all 0.2s;\n  border-radius: 8px;\n}\n\n.DrawingNode-wrapper:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n}\n\n/* 预览区域 */\n.DrawingNode-preview {\n  width: 100%;\n  height: 120px;\n  background: #f8f9fa;\n  border-radius: 6px;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid #e9ecef;\n  margin-bottom: 10px;\n  transition: all 0.2s;\n}\n\n.DrawingNode-wrapper:hover .DrawingNode-preview {\n  border-color: #667eea;\n}\n\n/* 预览图片 */\n.DrawingNode-preview-image {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n/* 占位符 */\n.DrawingNode-placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  color: #adb5bd;\n  padding: 16px;\n  text-align: center;\n}\n\n.DrawingNode-placeholder-icon {\n  font-size: 36px;\n  opacity: 0.6;\n  animation: DrawingNode-pulse 2s ease-in-out infinite;\n}\n\n@keyframes DrawingNode-pulse {\n  0%, 100% {\n    transform: scale(1);\n    opacity: 0.6;\n  }\n  50% {\n    transform: scale(1.1);\n    opacity: 0.8;\n  }\n}\n\n.DrawingNode-placeholder-text {\n  font-size: 12px;\n  font-weight: 600;\n  color: #6c757d;\n}\n\n/* 状态标识 */\n.DrawingNode-status {\n  display: flex;\n  justify-content: center;\n  gap: 6px;\n  flex-wrap: wrap;\n  margin-bottom: 8px;\n}\n\n.DrawingNode-status-badge {\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.DrawingNode-status-badge-success {\n  background: #d4edda;\n  color: #155724;\n}\n\n.DrawingNode-status-badge-empty {\n  background: #fff3cd;\n  color: #856404;\n}\n\n.DrawingNode-status-badge-warning {\n  background: #fff3cd;\n  color: #856404;\n}\n\n.DrawingNode-status-badge-info {\n  background: #d1ecf1;\n  color: #0c5460;\n}\n\n/* 提示 */\n.DrawingNode-hint {\n  font-size: 11px;\n  color: #6c757d;\n  text-align: center;\n  padding: 6px;\n  background: #f0f4ff;\n  border-radius: 4px;\n  border-left: 2px solid #667eea;\n}\n\n/* 响应式 */\n@media (max-width: 768px) {\n  .DrawingNode-wrapper {\n    width: 160px;\n  }\n  \n  .DrawingNode-preview {\n    height: 100px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
